if (typeof ProductPage !== "function") {
  class ProductPage extends HTMLElement {
    constructor() {
      super();
      this.$gallerySwiper = document.querySelector('[data-id="product-gallery-swiper"]');

      this.pickupAvailabilityExtended = this.querySelector(
        "pickup-availability-extended"
      );

      // Product variant event listener for theme specific logic

      this.productVariants = this.querySelector(
        "product-variants[data-main-product-variants]"
      );
      if (this.productVariants) {
        this.automaticDiscountEnabled = this.productVariants.getAttribute('data-global-automatic_discount_enabled') === 'true';
        this.automaticDiscountValue = this.productVariants.getAttribute('data-global-automatic_discount_value');
        this.automaticDiscountVendor = this.productVariants.getAttribute('data-global-automatic_discount_vendor');
        this.productVendor = this.productVariants.getAttribute('data-product-vendor');

        this.productVariants.addEventListener(
          "VARIANT_CHANGE",
          this.onVariantChangeHandler.bind(this)
        );
        this.onVariantChangeHandler({ target: this.productVariants });

        // refresh color
        this.querySelectorAll(".product-variant__item--radio").forEach(
          (elm) => {
            elm.addEventListener("click", (e) => {
              if (elm.classList.contains("product-variant__item--color")) {
                elm
                  .closest(".product-variant")
                  .querySelector(
                    ".product-variant__item-text-label"
                  ).textContent = elm.querySelector("input").value;
              }
            });
          }
        );
      }

      // show cart drawer when element is added to cart

      if (
        !document.body.classList.contains("template-cart") &&
        KROWN.settings.cart_action == "overlay"
      ) {
        let addToCartEnter = false;
        if (this.querySelector("[data-js-product-add-to-cart]")) {
          this.querySelector("[data-js-product-add-to-cart]").addEventListener(
            "keyup",
            (e) => {
              if (e.keyCode == window.KEYCODES.RETURN) {
                addToCartEnter = true;
              }
            }
          );
        }

        if (this.querySelector("[data-js-product-form]")) {
          this.querySelector("[data-js-product-form]").addEventListener(
            "add-to-cart",
            () => {
              document.getElementById("site-cart-sidebar").show();
              if (document.getElementById("cart-recommendations-sidebar")) {
                document
                  .getElementById("cart-recommendations-sidebar")
                  .generateRecommendations();
              }
              if (addToCartEnter) {
                setTimeout(() => {
                  document
                    .querySelector("#site-cart-sidebar [data-js-close]")
                    .focus();
                }, 200);
              }
            }
          );
        }
      }

      // Check for models

      const models = this.querySelectorAll("product-model");
      if (models.length > 0) {
        window.ProductModel.loadShopifyXR();
        this.xrButton = this.querySelector(".product-gallery__view-in-space");
      }

      // hide buy now button if stock disabled

      const addToCartButton = this.querySelector(
        "[data-js-product-add-to-cart][data-main-product-add-to-cart]"
      );
      if (addToCartButton) {
        if (addToCartButton.classList.contains("disabled")) {
          this.querySelector("product-form").classList.add(
            "disable-buy-button"
          );
        } else {
          this.querySelector("product-form").classList.remove(
            "disable-buy-button"
          );
        }
        const buyObserver = new MutationObserver(() => {
          if (addToCartButton.classList.contains("disabled")) {
            this.querySelector("product-form").classList.add(
              "disable-buy-button"
            );
          } else {
            this.querySelector("product-form").classList.remove(
              "disable-buy-button"
            );
          }
        });
        buyObserver.observe(addToCartButton, {
          attributes: true,
          childList: false,
          subtree: false,
        });
      }

      // update secondary price if present

      this.priceCompact = this.querySelector("[data-js-product-price-compact]");
      this.priceExtended = this.querySelector(
        "[data-js-product-price-extended"
      );

      if (this.priceCompact) {
        this.priceCompact.priceOriginal = this.priceCompact.querySelector(
          "[data-js-product-price-original]"
        );
        this.priceCompact.priceCompare = this.priceCompact.querySelector(
          "[data-js-product-price-compare]"
        );
        this.priceCompact.priceUnit = this.priceCompact.querySelector(
          "[data-js-product-price-unit]"
        );
      }
      if (this.priceExtended) {
        this.priceExtended.priceOriginal = this.priceExtended.querySelector(
          "[data-js-product-price-original]"
        );
        this.priceExtended.priceCompare = this.priceExtended.querySelector(
          "[data-js-product-price-compare]"
        );
        this.priceExtended.priceSaving = this.priceExtended.querySelector(
          "[data-js-product-price-saving]"
        );
        this.priceExtended.priceUnit = this.priceExtended.querySelector(
          "[data-js-product-price-unit]"
        );
      }
    }

    thumbnailNavigationHelper(index = 0) {
      this.querySelectorAll(".product-gallery__thumbnails .thumbnail").forEach(
        (elm, i) => {
          if (i == index) elm.classList.add("active");
          else elm.classList.remove("active");
        }
      );
    }

    onVariantChangeHandler(e) {
      let variant = e.target.currentVariant;

      if (variant) {
        // image handling
        // variant.featured_media.id: string; // ID used for select image in gallery

        if (variant.featured_media != null) {
          const targetSlide = document.querySelector(`[data-swiper-point-id="${variant.featured_media.id}"]`);

          if (targetSlide) {
            const slideIndex = targetSlide.getAttribute('data-swiper-point-index');

            if (slideIndex !== null) {
              this.$gallerySwiper.swiper.slideTo(Number(slideIndex), 1000); // Scroll to the slide with animation duration of 1000ms
            }

            // change main image
            // TODO use change image widget
            const sourceImage = targetSlide.getAttribute('data-change-image-src');
            const targetImage = targetSlide.getAttribute('data-change-image-target');
            const $targetImage = document.querySelector(targetImage);
            $targetImage.setAttribute('src', sourceImage);
          }
        }

        // refresh pickup availability widgets

        if (
          this.pickupAvailabilityExtended &&
          this.pickupAvailabilityExtended.classList.contains("active")
        ) {
          this.querySelector("pickup-availability-extended").fetchAvailability(
            variant.id
          );
        }

        if (variant) {
          let priceNoVatElms = document.querySelectorAll(
            "[data-js-product-price-no-vat]"
          );

          priceNoVatElms.forEach((elm) => {
            let priceNoVat = window.variantsPrices.find(
              (item) => item.id === variant.id
            );
            elm.innerHTML = priceNoVat.price;
          });
        } else {
          this.priceNoVat.innerHTML = "";
        }
      }

      // update prices (overwrites the framework)

      if (this.priceCompact) {
        if (!variant) {
          if (
            !(
              this.productVariants.variantRequired &&
              this.productVariants.noVariantSelectedYet
            )
          ) {
            this.priceCompact.classList.add("hide");
            this.priceCompact.priceOriginal.innerHTML = "";
            this.priceCompact.priceCompare.innerHTML = "";
            this.priceCompact.priceUnit.innerHTML = "";
          }
        } else {
          var price = variant.price;
          var compareAtPrice = variant.compare_at_price;

          console.log(this.automaticDiscountEnabled, this.productVendor === this.automaticDiscountVendor, variant);

          if (this.automaticDiscountEnabled && this.productVendor === this.automaticDiscountVendor) { 
            compareAtPrice = variant.price;
            price = variant.price - (variant.price * this.automaticDiscountValue / 100);

            console.log(this.automaticDiscountValue, price, compareAtPrice, this.automaticDiscountValue);

            this.priceCompact.priceOriginal.innerHTML = this.productVariants._formatMoney(
              price,
              KROWN.settings.shop_money_format
            );
            this.priceCompact.priceCompare.innerHTML = `<span>${this.productVariants._formatMoney(compareAtPrice, KROWN.settings.shop_money_format)}</span>`;
            return;
          }

          this.priceCompact.classList.remove("hide");
          this.priceCompact.priceOriginal.innerHTML =
            this.productVariants._formatMoney(
              variant.price,
              KROWN.settings.shop_money_format
            );
          if (variant.compare_at_price > variant.price) {
            this.priceCompact.priceCompare.innerHTML =
              this.productVariants._formatMoney(
                variant.compare_at_price,
                KROWN.settings.shop_money_format
              );
            this.priceCompact.priceCompare.innerHTML = `<span>${this.productVariants._formatMoney(variant.compare_at_price, KROWN.settings.shop_money_format)}</span><span class="product-item__badge">-${Math.round(Math.abs((variant.price * 100 / variant.compare_at_price) - 100))}%</span>`;
          } else {
            this.priceCompact.priceCompare.innerHTML = "";
          }

          if (variant.unit_price_measurement) {
            this.priceCompact.priceUnit.innerHTML = `
							  ${this.productVariants._formatMoney(
              variant.unit_price,
              KROWN.settings.shop_money_format
            )} /
							  ${variant.unit_price_measurement.reference_value != 1
                ? variant.unit_price_measurement.reference_value + " "
                : ""
              }
							  ${variant.unit_price_measurement.reference_unit}
						  `;
          } else {
            this.priceCompact.priceUnit.innerHTML = "";
          }
        }
      }

      if (this.priceExtended) {
        if (!variant) {
          this.priceExtended.classList.add("hide");
          this.priceExtended.priceOriginal.innerHTML = "";
          this.priceExtended.priceCompare.innerHTML = "";
          this.priceExtended.priceUnit.innerHTML = "";
          this.priceExtended.priceSaving.innerHTML = "";
        } else {
          this.priceExtended.classList.remove("hide");
          this.priceExtended.priceOriginal.innerHTML =
            this.productVariants._formatMoney(
              variant.price,
              KROWN.settings.shop_money_format
            );
          if (variant.compare_at_price > variant.price) {
            this.priceExtended.priceCompare.innerHTML = `<span>${this.productVariants._formatMoney(
              variant.compare_at_price,
              KROWN.settings.shop_money_format
            )}</span>`;
            this.priceExtended.priceSaving.innerHTML = `<span>${KROWN.settings.locales.product_compare_price.replace(
              "$SAVE_PRICE",
              this.productVariants._formatMoney(
                variant.compare_at_price - variant.price,
                KROWN.settings.shop_money_format
              )
            )}</span>`;
          } else {
            this.priceExtended.priceCompare.innerHTML = "";
            this.priceExtended.priceSaving.innerHTML = "";
          }

          if (variant.unit_price_measurement) {
            this.priceExtended.priceUnit.innerHTML = `
							  ${this.productVariants._formatMoney(
              variant.unit_price,
              KROWN.settings.shop_money_format
            )} /
							  ${variant.unit_price_measurement.reference_value != 1
                ? variant.unit_price_measurement.reference_value + " "
                : ""
              }
							  ${variant.unit_price_measurement.reference_unit}
						  `;
          } else {
            this.priceExtended.priceUnit.innerHTML = "";
          }
        }
      }
    }

    _pauseAllMedia() {
      document
        .querySelectorAll(".product-gallery .js-youtube")
        .forEach((video) => {
          video.contentWindow.postMessage(
            '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
            "*"
          );
        });
      document
        .querySelectorAll(".product-gallery .js-vimeo")
        .forEach((video) => {
          video.contentWindow.postMessage('{"method":"pause"}', "*");
        });
      document
        .querySelectorAll(".product-gallery video")
        .forEach((video) => video.pause());
      document
        .querySelectorAll(".product-gallery product-model")
        .forEach((model) => {
          if (model.modelViewerUI) model.modelViewerUI.pause();
        });
    }

    _playMedia(media) {
      switch (media.dataset.productMediaType) {
        case "video":
          if (media.querySelector("video")) {
            media.querySelector("video").play();
          }
          break;
        case "external_video-youtube":
          if (media.querySelector(".js-youtube")) {
            media
              .querySelector(".js-youtube")
              .contentWindow.postMessage(
                '{"event":"command","func":"' + "playVideo" + '","args":""}',
                "*"
              );
          }
          break;
        case "external_video-vimeo":
          if (media.querySelector(".js-vimeo")) {
            media
              .querySelector(".js-vimeo")
              .contentWindow.postMessage('{"method":"play"}', "*");
          }
          break;
      }
    }

    _formatMoney(cents, format) {
      if (typeof cents === "string") {
        cents = cents.replace(".", "");
      }

      let value = "";
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || moneyFormat;

      function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ",";
        decimal = decimal || ".";

        if (isNaN(number) || number === null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        const parts = number.split(".");
        const dollarsAmount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1" + thousands
        );
        const centsAmount = parts[1] ? decimal + parts[1] : "";

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
          value = formatWithDelimiters(cents, 2);
          break;
        case "amount_no_decimals":
          value = formatWithDelimiters(cents, 0);
          break;
        case "amount_with_comma_separator":
          value = formatWithDelimiters(cents, 2, ".", ",");
          break;
        case "amount_with_space_separator":
          value = formatWithDelimiters(cents, 2, " ", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          value = formatWithDelimiters(cents, 0, ".", ",");
          break;
        case "amount_no_decimals_with_space_separator":
          value = formatWithDelimiters(cents, 0, " ");
          break;
        case "amount_with_apostrophe_separator":
          value = formatWithDelimiters(cents, 2, "'");
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }
  }

  if (typeof customElements.get("product-page") == "undefined") {
    customElements.define("product-page", ProductPage);
  }
}
